var map = {
	"./arrow-down.svg": "./web/themes/custom/hetdepot/dev/icons/arrow-down.svg",
	"./arrow-right.svg": "./web/themes/custom/hetdepot/dev/icons/arrow-right.svg",
	"./arrow-thick-right.svg": "./web/themes/custom/hetdepot/dev/icons/arrow-thick-right.svg",
	"./arrowLeft.svg": "./web/themes/custom/hetdepot/dev/icons/arrowLeft.svg",
	"./arrowRight.svg": "./web/themes/custom/hetdepot/dev/icons/arrowRight.svg",
	"./carret.svg": "./web/themes/custom/hetdepot/dev/icons/carret.svg",
	"./close.svg": "./web/themes/custom/hetdepot/dev/icons/close.svg",
	"./discord.svg": "./web/themes/custom/hetdepot/dev/icons/discord.svg",
	"./facebook.svg": "./web/themes/custom/hetdepot/dev/icons/facebook.svg",
	"./fb-rounded.svg": "./web/themes/custom/hetdepot/dev/icons/fb-rounded.svg",
	"./instagram.svg": "./web/themes/custom/hetdepot/dev/icons/instagram.svg",
	"./linkedin.svg": "./web/themes/custom/hetdepot/dev/icons/linkedin.svg",
	"./logo.svg": "./web/themes/custom/hetdepot/dev/icons/logo.svg",
	"./pinterest.svg": "./web/themes/custom/hetdepot/dev/icons/pinterest.svg",
	"./play.svg": "./web/themes/custom/hetdepot/dev/icons/play.svg",
	"./plus.svg": "./web/themes/custom/hetdepot/dev/icons/plus.svg",
	"./quote.svg": "./web/themes/custom/hetdepot/dev/icons/quote.svg",
	"./reddit.svg": "./web/themes/custom/hetdepot/dev/icons/reddit.svg",
	"./snapchat.svg": "./web/themes/custom/hetdepot/dev/icons/snapchat.svg",
	"./soundcloud.svg": "./web/themes/custom/hetdepot/dev/icons/soundcloud.svg",
	"./spotify.svg": "./web/themes/custom/hetdepot/dev/icons/spotify.svg",
	"./ticketswap.svg": "./web/themes/custom/hetdepot/dev/icons/ticketswap.svg",
	"./triangleDown.svg": "./web/themes/custom/hetdepot/dev/icons/triangleDown.svg",
	"./twitter.svg": "./web/themes/custom/hetdepot/dev/icons/twitter.svg",
	"./vibe.svg": "./web/themes/custom/hetdepot/dev/icons/vibe.svg",
	"./website.svg": "./web/themes/custom/hetdepot/dev/icons/website.svg",
	"./youtube.svg": "./web/themes/custom/hetdepot/dev/icons/youtube.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./web/themes/custom/hetdepot/dev/icons sync recursive \\.svg$";